import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetPromptsQuery,
  GetPromptsQueryVariables,
} from '#/graphql/generated';

export const GET_PROMPTS: TypedDocumentNode<
  GetPromptsQuery,
  GetPromptsQueryVariables
> = gql`
  query GetPrompts {
    prompts {
      prompts {
        id
        value
        createdAt
        updatedAt
      }
    }
  }
`;
